import VueI18n, {LocaleMessages} from 'vue-i18n';
import moment from "moment-timezone";
import axios from "axios";
import ToastService from 'primevue/toastservice';
import Vue from 'vue';

export function getMeta(metaName, defaultValue: string | null = 'ru') {
  const metas = document.getElementsByTagName('meta');

  for (let i = 0; i < metas.length; i++) {
    if (metas[i].getAttribute('name') === metaName) {
      return metas[i].getAttribute('content');
    }
  }
  return defaultValue;
}

export const i18nPluralizationRules = {
  /**
   * @param choice {number} индекс выбора, переданный в $tc: `$tc('path.to.rule', choiceIndex)`
   * @param choicesLength {number} общее количество доступных вариантов
   * @returns финальный индекс для выбора соответственного варианта слова
   */
  ru(choice, choicesLength) {
    // this === VueI18n экземпляра, так что свойство locale также существует здесь

    if (choice === 0) {
      return 0;
    }

    const teen = choice > 10 && choice < 20;
    const endsWithOne = choice % 10 === 1;

    if (choicesLength < 4) {
      return (!teen && endsWithOne) ? 1 : 2;
    }
    if (!teen && endsWithOne) {
      return 1;
    }
    if (!teen && choice % 10 >= 2 && choice % 10 <= 4) {
      return 2;
    }

    return (choicesLength < 4) ? 2 : 3;
  },
}

export function getI18n(language?: string, messages: null | LocaleMessages = null) {
  const lang: string = language || getMeta('language') as string;
  return new VueI18n({
    locale: lang as string,
    fallbackLocale: lang as string,
    messages: messages || {} as LocaleMessages,
    // Ключ - язык, для которого будет применяться правило, в этом примере - `'ru'`
    // Value - функция плюрализации
    pluralizationRules: i18nPluralizationRules,
    silentTranslationWarn: true,
    silentFallbackWarn: true,
  });
}

import PrimeVue from 'primevue/config';
import Toast from "primevue/toast";
Vue.use(PrimeVue);
Vue.use(ToastService);
import 'primevue/resources/themes/bootstrap4-light-blue/theme.css';
import 'primeicons/primeicons.css';


export function initVueDefaults() {
  Vue.use(PrimeVue);
  Vue.use(ToastService);

  moment.tz.setDefault("Europe/Moscow")
  axios.defaults.headers.common = {
    'X-Requested-With': 'XMLHttpRequest',
    'X-Agent': 'backoffice-lib-js',
  };
  return {
    i18n: getI18n(),
    components: {
      Toast
    }
  }
}
